import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useFormatCurrency } from "@/context/CountryContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Star, MapPin, Wrench, Search as SearchIcon } from "lucide-react";

export default function Providers() {
  const navigate = useNavigate();
  const formatCurrency = useFormatCurrency();
  const [providers, setProviders] = useState([]);
  const [q, setQ] = useState("");

  const load = () => api.get("/providers", { params: q ? { profession: q } : {} }).then((r) => setProviders(r.data));
  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-display text-3xl font-bold text-secondary">Prestataires de service</h1>
      <p className="text-muted-foreground">Demandez un devis et réservez un RDV en ligne.</p>

      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="mt-6 flex gap-2 max-w-md">
        <div className="flex items-center gap-2 flex-1 bg-card border border-border rounded-lg px-3">
          <SearchIcon className="w-4 h-4 text-muted-foreground" />
          <Input data-testid="provider-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Plombier, coiffeuse…" className="border-0 shadow-none focus-visible:ring-0" />
        </div>
        <Button type="submit" className="bg-primary hover:bg-primary/90">Chercher</Button>
      </form>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
        {providers.map((p, i) => (
          <div key={p.provider_id} data-testid={`provider-${p.provider_id}`}
            onClick={() => navigate(`/prestataires/${p.provider_id}`)}
            className="cursor-pointer bg-card border border-border rounded-xl overflow-hidden hover:-translate-y-1 transition-transform animate-fade-up" style={{ animationDelay: `${i * 50}ms` }}>
            <div className="h-40 bg-muted overflow-hidden">
              {p.photo_url ? <img src={p.photo_url} alt={p.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center"><Wrench className="w-10 h-10 text-muted-foreground/40" /></div>}
            </div>
            <div className="p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-display font-bold text-secondary">{p.name}</h3>
                <span className="text-xs flex items-center gap-0.5 text-amber-500"><Star className="w-3.5 h-3.5 fill-amber-500" />{p.rating}</span>
              </div>
              <Badge variant="secondary" className="mt-1">{p.profession}</Badge>
              <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{p.bio}</p>
              <div className="flex items-center justify-between mt-3 text-sm">
                <span className="flex items-center gap-1 text-muted-foreground"><MapPin className="w-3.5 h-3.5" />{p.city}</span>
                {p.base_rate ? <span className="text-primary font-semibold">dès {formatCurrency(p.base_rate)}</span> : null}
              </div>
            </div>
          </div>
        ))}
      </div>
      {providers.length === 0 && <div className="text-center py-20 text-muted-foreground">Aucun prestataire trouvé.</div>}
    </div>
  );
}
